import Utils from './utils';

declare var ShoppingBasketParms: any;
declare var globalParms: any;

/**********************************
* Mega Menu Functions 
**********************************/

function getElementIndex(node: HTMLElement): number {
    var index = 0;
    while ((node = node.previousElementSibling as HTMLElement)) {
        index++;
    }
    return index;
}

//Initialise menu
function initMenu(menu: any): void {
    //Only load the initial menu for desktop
    if (screen.width > 1023) {
        menu.setAttribute('data-display', 'd');
        var level2 = document.querySelectorAll('[data-navLevel = "2"]')[0];
        if (level2) {
            level2.querySelector('.category-column > ul > li:first-child')?.setAttribute('data-hovered', 'true')
            level2.querySelector('.category-column > ul > li:first-child button')?.setAttribute('aria-expanded', 'true');
            level2.querySelectorAll('.category-column-sub')[0].setAttribute('data-active', 'true');
        }
    }
    else {
        menu.setAttribute('data-display', 'm');
    }
}

//Reset menu
function resetMenu(menu: any): void {
    menu.querySelectorAll('[aria-expanded]').forEach(function (item: any) {
        item.setAttribute('aria-expanded', 'false');
    });
    menu.querySelectorAll('[data-active]:not([data-navlevel="3"])').forEach(function (item: any) {
        item.setAttribute('data-active', 'false');
    });
    menu.querySelectorAll('[data-hovered]').forEach(function (item: any) {
        item.setAttribute('data-hovered', 'false');
    });
    menu.querySelectorAll('.active').forEach(function (item: any) {
        item.classList.remove('active');
    });

    initMenu(menu);
}

//action: on|off
function onOffItems(element: HTMLElement, action: string): void {
    element.setAttribute('aria-expanded', (action === "on") ? 'true' : 'false');
    if (action === "on") {
        element.parentElement?.classList.add('active');
    } else {
        element.parentElement?.classList.remove('active');
    }

    element.nextElementSibling?.setAttribute('data-active', (action === "on") ? 'true' : 'false');
}

function handleMobileMenu(this: HTMLElement) {
    var expanded = this.getAttribute('aria-expanded');
    var body = document.body;
    if (expanded == "false") {
        this.setAttribute('aria-expanded', "true");
        document.querySelector('header.site-head')?.setAttribute('data-mobile-toggled', "true");
        body.classList.add("menu-open");
    } else {
        this.setAttribute('aria-expanded', "false");
        document.querySelector('header.site-head')?.setAttribute('data-mobile-toggled', "false");
        body.classList.remove("menu-open");
        //TODO: what are we resetting? resetMenu();
    }
}

function closeMobileMenu() {
    var body = document.body;
    document.querySelector('button.mobile-menu')?.setAttribute('aria-expanded', "false");
    document.querySelector('header.site-head')?.setAttribute('data-mobile-toggled', "false");
    body.classList.remove("menu-open");
    //    handleMobileMenu;
}

// Standard offset.top not working properly: https://medium.com/@alexcambose/js-offsettop-property-is-not-great-and-here-is-why-b79842ef7582
function getOffsetTop(element: any) {
    let offsetTop = 0;
    let parentElem = element;
    while (parentElem) {
        offsetTop += parentElem.offsetTop;
        parentElem = parentElem.offsetParent;
    }
    return offsetTop;
}

//we have js
if (document.documentElement.classList.contains('no-js')) {
    document.documentElement.classList.remove('no-js');
    document.documentElement.classList.add('js');

    if (document.getElementsByClassName('site-head').length) {

        var menu = document.querySelector('#primary-navigation');

        if (menu) {

            initMenu(menu);

            //TODO - add debounce - resize init();
            //window.addEventListener('resize', function (e) {
            //    if (screen.width > 1023 && menu.getAttribute('data-display') != "d") {
            //        resetMenu(menu);
            //    }
            //    else if (screen.width <= 1023 && menu.getAttribute('data-display') != "m") {
            //        resetMenu(menu);
            //    }
            //});

            //Main menu click event
            menu.addEventListener('click', function (e) {
                let clickElement = e.srcElement;
                if ((clickElement as HTMLElement).tagName.toLowerCase() == 'span' || (clickElement as HTMLElement).tagName.toLowerCase() == 'svg') {
                    clickElement = (clickElement as HTMLElement)?.closest('button')
                }
                if ((clickElement as HTMLElement)?.classList.contains('cat-link')) {
                    var level = (clickElement as HTMLElement)?.closest('[data-navLevel]')?.getAttribute("data-navLevel");
                    if (level != "2") {
                        //Simple toggle
                        if ((clickElement as HTMLElement)?.getAttribute('aria-expanded') == "false") {
                            //Switch off any items that are active
                            var activeItemLevel = document.querySelector('[data-navLevel = "' + level + '"]');
                            var activeItems = activeItemLevel?.querySelectorAll('button[aria-expanded="true"]');
                            for (var i = 0, max = activeItems?.length; i < (max ? max : 0); i++) {
                                if (activeItems != null && activeItems[i]?.closest('[data-navLevel]')?.getAttribute("data-navLevel") == level) {
                                    onOffItems(activeItems[i] as HTMLElement, 'off');
                                }
                            }
                            onOffItems((clickElement as HTMLElement), 'on');
                        }
                        else {
                            onOffItems((clickElement as HTMLElement), 'off');
                        }
                    }
                    else {
                        //Level 2 items
                        var index = getElementIndex((clickElement as HTMLElement)?.parentElement as HTMLElement);
                        var menuSubs = document.querySelectorAll('.category-column-sub');

                        var menuSub = null;
                        for (var i = 0, max1 = menuSubs.length; i < max1; i++) {
                            if (index == i) {
                                menuSub = menuSubs[i];
                            }
                        }
                        if ((clickElement as HTMLElement).getAttribute('aria-expanded') == "false") {
                            //Switch off any active items first
                            var activeItem = document.querySelector('.category-column ul li[data-hovered="true"]');
                            if (activeItem !== null) {
                                var activeItemIndex = getElementIndex(activeItem as HTMLElement);
                                activeItem.setAttribute('data-hovered', 'false');//li
                                activeItem.querySelector('button')?.setAttribute('aria-expanded', 'false');//button
                                var menuSubOff = null;
                                for (var i = 0, max2 = menuSubs.length; i < max2; i++) {
                                    if (activeItemIndex == i) {
                                        menuSubOff = menuSubs[i];
                                    }
                                }
                                menuSubOff?.setAttribute('data-active', 'false');
                            }
                            (clickElement as HTMLElement).setAttribute('aria-expanded', 'true');
                            (clickElement as HTMLElement).parentElement?.setAttribute('data-hovered', 'true');
                            menuSub?.setAttribute('data-active', 'true');
                        }
                    }
                }
                else {
                    // if non .cat-link
                    if ((clickElement as HTMLElement).closest('[data-navLevel]')?.getAttribute("data-navLevel") == "1") {
                        resetMenu(menu);
                    }
                }

            });

            //Close menu when user clicks outside
            document.addEventListener('click', function (e) {
                // This closes menu on click outside
                let target = e.target;
                if (menu && target && !menu.contains(target as HTMLElement)) {
                    resetMenu(menu);
                }
            });

            //TODO // key functions for keyboard navigation
            //var level2MenuCatColumns = menu.querySelectorAll('.category-column');
            //for (var i = 0, max = level2MenuCatColumns.length; i < max; i++) {
            //    var level2MenuCatColumn = level2MenuCatColumns[i];
            //    level2MenuCatColumn.addEventListener('keyup', function (e) {
            //        if ((e as Event).key == "Enter") {
            //            console.log(e.srcElement);
            //            var firstElementSub = document.querySelectorAll('.category-column-sub[data-active="true"] ul li a')[0];
            //            firstElementSub.focus();
            //        }
            //    });
            //}

            var level2MenuSub = menu.querySelectorAll('.category-column-sub');
            let max = level2MenuSub.length;
            for (var i = 0; i < max; i++) {
                var level2MenuSubAnchors = level2MenuSub[i].querySelectorAll('a');
                let max2 = level2MenuSubAnchors.length;
                for (var b = 0; b < max2; b++) {
                    if (b + 1 == max2) {
                        level2MenuSubAnchors[b].addEventListener('keydown', function (e) {
                            if (e.keyCode == 9) {
                                menu?.querySelector('.category-column li[data-hovered="true"]')?.querySelector('button')?.focus();
                            }
                        });
                    }
                }
            }

            //Breadcrumb functions
            var breadcrumbButtons = menu.querySelectorAll('.breadcrumb .parent-page');
            var maxBreadcrumbs = breadcrumbButtons.length;
            for (var i = 0; i < maxBreadcrumbs; i++) {
                breadcrumbButtons[i].addEventListener('click', function (e) {
                    var navLevelElm = (e.srcElement as HTMLElement).closest('[data-navlevel]') as HTMLElement;
                    var navLevel = navLevelElm.getAttribute('data-navlevel');
                    if (navLevel && parseInt(navLevel) != 2) {
                        navLevelElm = navLevelElm.closest('li') as HTMLElement;
                        navLevelElm.setAttribute('class', 'false');
                    }
                    else {
                        navLevelElm.setAttribute('data-active', 'false');
                    }

                    navLevelElm.querySelectorAll('[aria-expanded]').forEach(function (item: any) {
                        item.setAttribute('aria-expanded', 'false');
                    });
                    navLevelElm.querySelectorAll('[data-active]:not([data-navlevel="3"])').forEach(function (item: any) {
                        item.setAttribute('data-active', 'false');
                    });
                    navLevelElm.querySelectorAll('[data-hovered]').forEach(function (item: any) {
                        item.setAttribute('data-hovered', 'false');
                    });
                    navLevelElm.querySelectorAll('.active').forEach(function (item: any) {
                        item.classList.remove('active');
                    });

                    if (navLevel && parseInt(navLevel) == 2) {
                        //Go up a level and switch off the button that opened the level
                        var navLevelElmUp1 = navLevelElm.closest('[data-navlevel="' + (parseInt(navLevel) - 1) + '"]');
                        var navLevelElmUp1Button = navLevelElmUp1?.querySelector('button[aria-expanded="true"]');
                        if (navLevelElmUp1Button != null) {
                            navLevelElmUp1Button.setAttribute('aria-expanded', 'false');
                        }
                    }
                });
            }

            //Mobile menu functions
            var mobilemenu = document.querySelector('button.mobile-menu');
            mobilemenu?.addEventListener("click", handleMobileMenu);

            var mobilebg = document.querySelector('.mobile-background');
            mobilebg?.addEventListener("click", closeMobileMenu);
        }

        ///////////////////////////////////////////////////////////////////
        //               Sticky search bar on mobile                     //
        ///////////////////////////////////////////////////////////////////

        var sh = document.querySelector(".site-head");
        var h = document.querySelector(".search-container");
        var stuck = false;
        var stickPoint = getOffsetTop(h);

        window.onscroll = function (e) {
            var offset = window.pageYOffset;

            if (!stuck && offset > stickPoint) {
                if (h) h.classList.add('stuck');
                if (sh) sh.classList.add('stuck');
                stuck = true;
            } else if (stuck && offset <= stickPoint) {
                if (h) h.classList.remove('stuck');;
                if (sh) sh.classList.remove('stuck');
                stuck = false
            }
        }
    }

    /*toggles, used in mobile footer used in all pages*/
    var ToggleButtons = document.querySelectorAll('[data-toggle-parent]');
    if (ToggleButtons.length) {
        ToggleButtons.forEach(function (toggle) {
            if (!toggle.classList.contains('click-bound')) {
                toggle.classList.add('click-bound');
                toggle.addEventListener('click', function (e) {
                    let elem = e.target as HTMLElement;
                    if (elem.getAttribute('aria-expanded') == "false") {
                        elem.setAttribute('aria-expanded', 'true')
                    }
                    else {
                        elem.setAttribute('aria-expanded', 'false');
                    }
                })
            }
        })
    }




    var loginPartial = document.querySelector(".loginPartial");
    var loginPartialMobile = document.getElementById("sign-in-mobile");

    if (loginPartial) {
        if (globalParms && globalParms.LoginPartialURL) {
            fetch(globalParms.LoginPartialURL)
                .then(response => response.text())
                .then(function (data) {
                    if (data && loginPartial) {
                        loginPartial.innerHTML = data;
                    }
                    if (data && loginPartialMobile) {
                        loginPartialMobile.innerHTML = data;
                    }
                });
        }
    }

    var accountLinks = document.querySelector(".account-links");

    if (accountLinks) {
        if (globalParms && globalParms.AccountLinksURL) {
            fetch(globalParms.AccountLinksURL)
                .then(response => response.text())
                .then(function (data) {
                    if (data && accountLinks) {
                        accountLinks.innerHTML = data;
                        var basketButton = document.getElementById("basketButton");
                        if (basketButton) {
                            basketButton.addEventListener("click", function () {
                                window.location.href = basketButton!.getAttribute("data-url")!;
                            });

                            ShoppingBasket_UpdateItemCount();
                        }
                    }
                });
        }
    }

    initLightYouTube();

    document.addEventListener('DOMContentLoaded', function () {
        let mainNavContainers = document.querySelectorAll('#nav-container ul li div[data-navlevel="2"]')
        let navHeight = 0;
        for (let i = 0; i < mainNavContainers.length; i++) {                
            let elemHeight = window.getComputedStyle(mainNavContainers[i]).getPropertyValue("height");
            if (Number(elemHeight.replace('px','')) > navHeight) {
                navHeight = Number(elemHeight.replace('px',''));
            }
        }
        let mainContent = document.getElementById('main-content');
        if (mainContent) {
            mainContent.style.minHeight = (navHeight - 86) + 'px';
        }
    });
}

export function ShoppingBasket_UpdateItemCount() {
    var itemCount = document.querySelector(".basket--link span.item-count");

    if (itemCount != null) {
        try {
            var cookie = Utils.getCookie(ShoppingBasketParms.CookieKey);
            if (cookie) {
                var basketDataJSON = JSON.parse(unescape(cookie));

                itemCount.innerHTML = basketDataJSON.NumberOfItems;

            } else {
                itemCount.innerHTML = "0";
            }
        }
        catch (err) { console.log(err) }
    }
}

/* Light YouTube Embeds by @labnol */
/* and img lazy loads */
/* Web: http://labnol.org/?p=27941 */

function initLightYouTube() {
    var div, n,
        v = document.getElementsByClassName("youtube-player");
    for (n = 0; n < v.length; n++) {
        div = document.createElement("div");
        div.setAttribute("data-id", (v[n] as any).dataset.id);
        div.innerHTML = labnolThumb((v[n] as any).dataset.id);
        div.onclick = labnolIframe;
        v[n].appendChild(div);
    }
    loadLazyImages();

    function labnolThumb(id: string) {
        var thumb = '<img lazy-src="https://i.ytimg.com/vi/ID/maxresdefault.jpg">', //hqdefault
            play = '<div class="play"></div>';
        return thumb.replace("ID", id) + play;
    }

    function labnolIframe(evt: Event) {
        let target = (evt.target as HTMLElement).parentNode;
        if (target) {
            var iframe = document.createElement("iframe");
            var embed = "https://www.youtube.com/embed/ID?autoplay=1";
            let dataID = (target as HTMLElement).getAttribute("data-id");
            if (dataID) iframe.setAttribute("src", embed.replace("ID", dataID as string));
            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute("allowfullscreen", "1");
            let parent = (target as HTMLElement).parentElement;
            if (parent) parent.replaceChild(iframe, target);
        }
    }

    // Lazy-load images. Observe images until they are loaded.
    function loadLazyImages() {
        var lazyLoadOptions = {
            // https://www.competa.com/blog/lazy-loading-with-the-intersection-observer/
            //root: document.querySelector('div.gak-container'), // Comment this to use the default browser's viewport.
            rootMargin: '25px',
            threshold: 0//1.0
        };

        //initImagesForProductListings();

        var myImgs = document.querySelectorAll('img[lazy-src]');
        try {
            var observer = new IntersectionObserver(function (entries) {
                //console.log('loadLazyImages: entries ' + entries.length);
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        // Load image
                        var imgElem = entry.target;
                        loadLazyImages_doImage(imgElem as HTMLElement);
                        //console.log('in the view');
                        observer.unobserve(imgElem);
                    } else {
                        //console.log('out of view');
                    }
                });
            }, lazyLoadOptions);

            myImgs.forEach(function (image) {
                observer.observe(image);
            });
        }
        catch (err) {
            loadLazyImages_notSupported(myImgs);
        }

        function loadLazyImages_notSupported(myImgs: any) {
            // IntersectionObserver (and forEach()) not supported on Safari and old versions of IE 28/01/2019.
            //console.log("lazy load images not supported");
            for (var i = 0, len = myImgs.length; i < len; i++) {
                loadLazyImages_doImage(myImgs[i]);
            }
        }

        function loadLazyImages_doImage(imgElem: HTMLElement) {
            setTimeout(function () {
                var realSrc = imgElem.getAttribute("lazy-src"); //$(imgElem).attr("lazy-src");
                if (realSrc) {
                    imgElem.setAttribute("src", realSrc); //.src = realSrc;
                    imgElem.removeAttribute("lazy-src"); //$(imgElem).removeAttr("lazy-src");
                }
            }, 1);
        }

        //function initImagesForProductListings() {
        //    $('ul.productListing').each(function (index) {
        //        var curProdList = $(this);
        //        loadImagesForProductListings_BasedOnView(curProdList);
        //    });
        //}
    }

};

//function loadImagesForProductListings_BasedOnView(prodListing) {
//    var isGridView = prodListing.hasClass('view-as-grid');
//    prodListing.find('.productImageWrapper img').each(function (index) {
//        var img = $(this);
//        setTimeout(function () {
//            var newImgUrl = img.closest('.innerwrapper').data(isGridView ? 'prodimggridview' : 'prodimglistview');
//            // Set the new Img Url to the proper attribute src or lazy-src.
//            if (img.attr("lazy-src")) {
//                img.attr("lazy-src", newImgUrl);
//            }
//            else if (img[0].src) {
//                img[0].src = newImgUrl;
//            }
//        }, 1);
//    });
//}